import script from "./CircularSpinner.vue?vue&type=script&setup=true&lang=ts"
export * from "./CircularSpinner.vue?vue&type=script&setup=true&lang=ts"

import "./CircularSpinner.vue?vue&type=style&index=0&id=3275de7e&lang=scss"

const __exports__ = script;

export default __exports__